import type { BrandLocales, LocaleBundle } from './types';

// Наложение бренд-оверрайдов на базовый словарь.
//
// Merge ОБЯЗАН быть глубоким. Поверхностный (`{...base[ns], ...overrides[ns]}`)
// на первый взгляд работает, но заменяет целиком вложенный объект: у WapClick
// в оверрайдах streams.form есть name/postback/redirect, и вместе с ними
// затирались form.traffback и form.redirect.popup — те ключи, которые бренд не
// переопределял. В интерфейсе это выглядит как подпись «form.traffback.label»
// вместо «TraffBack URL».
function deepMerge<T extends Record<string, unknown>>(base: T, patch: Record<string, unknown>): T {
  const result: Record<string, unknown> = { ...base };

  for (const [key, value] of Object.entries(patch)) {
    const current = result[key];
    const bothObjects =
      value && typeof value === 'object' && !Array.isArray(value) &&
      current && typeof current === 'object' && !Array.isArray(current);

    result[key] = bothObjects
      ? deepMerge(current as Record<string, unknown>, value as Record<string, unknown>)
      : value;
  }

  return result as T;
}

export function withBrandOverrides(
  base: LocaleBundle,
  overrides: BrandLocales[keyof BrandLocales],
): LocaleBundle {
  if (!overrides) return base;

  const merged: LocaleBundle = { ...base };
  for (const [namespace, keys] of Object.entries(overrides)) {
    merged[namespace] = deepMerge(base[namespace] ?? {}, keys);
  }

  return merged;
}
